import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useIsUserAdmin = (enabled: boolean) => {
  const adminPermissionsService = useServices().adminPermissionsService;

  return useQuery({
    queryKey: ['isUserAdmin'],
    queryFn: adminPermissionsService.isAdmin,
    enabled,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export const useCanUserSeeOrganizations = (enabled: boolean) => {
  const organizationsService = useServices().organizationsService;

  return useQuery({
    queryKey: ['userOrganizationsAsInstructor'],
    queryFn: organizationsService.getOrganizations,
    enabled,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export const useIsUserMember = () => {
  const profileService = useServices().profileService;

  return useQuery({
    queryKey: ['isUserMember'],
    queryFn: profileService.checkIfUserIsMember,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
